import type { Role, SessionResponse } from "../../shared/api";
import { PERMISSIONS, type Job } from "../../shared/permissions";
import { legacyRedirect, screens, type Screen } from "../screens";

export const LOGIN = "/login";
export const SET_PASSWORD = "/set-password";

/** Write jobs (upload, manual entry, ...): whether the buttons are drawn. The API checks the right itself. */
export const canWrite = (role: Role) => (PERMISSIONS.write as readonly Role[]).includes(role);

/** Screens gated by a job; the others are open to every role (#71). */
const SCREEN_JOB: Partial<Record<string, Job>> = { E8: "audit", E9: "users", E10: "settings" };

/** Menu for a role. Rights are enforced by the API; this only decides what is shown (spec §13). */
export const menuFor = (role: Role): Screen[] =>
  screens.filter((s) => {
    const job = SCREEN_JOB[s.id];
    return !job || (PERMISSIONS[job] as readonly Role[]).includes(role);
  });

/** Where the current path must go instead, or null when it may stay. `session` undefined = still loading. */
export function redirectFor(path: string, session: SessionResponse | null | undefined): string | null {
  if (session === undefined) return null;
  if (session === null) return path === LOGIN ? null : LOGIN;
  if (session.mustSetPassword) return path === SET_PASSWORD ? null : SET_PASSWORD;
  if (path === LOGIN || path === SET_PASSWORD || path === "/") return screens[0]!.path;
  return legacyRedirect(path); // eski /eN yenisine; bilinmeyen yol ve rolün göremediği ekran kabukta açıklanır (App: NoticePage), sessizce yönlendirilmez
}
